module.exports = __webpack_public_path__ + "img/zoom-out.37fc2d86.svg";